import { initializeApp } from "firebase/app";
import { getAnalytics } from 'firebase/analytics';
import { getPerformance } from "firebase/performance";
import { getFirestore, initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";

const firebase = initializeApp({
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
  measurementId: process.env.REACT_APP_MEASUREMENT_ID

});

const analytics = getAnalytics(firebase);

const performance = getPerformance(firebase);

/// Catalog reads are served from an IndexedDB copy first and reconciled with the server
/// right after, so repeat visits paint without waiting on the network. The multiple tab
/// manager is required: without it the cache refuses to start when a second tab is open.
/// Must run before any getFirestore call, and cacheSizeBytes must not be set alongside it.
const createFirestore = () => {

  try {

    return initializeFirestore(firebase, {
      localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
    });

  } catch (error) {

    /// Storage can be unavailable (private browsing, restricted storage). The app works
    /// fine without the cache, so fall back to the default in-memory one.
    return getFirestore(firebase);

  }

}

const firestore = createFirestore();

analytics.app.automaticDataCollectionEnabled = true;

performance.app.automaticDataCollectionEnabled = true;

export {
  firebase,
  analytics,
  firestore
}
